import { Link } from "@tanstack/react-router";
import Thumb from "./Thumb";
import type { TGenericPost } from "../typings";
import TagsList from "@/components/PostTagsList";
import { LinkBuilder } from "@/services/link-builder";
import cls from "./styles.module.css";
import cn from "clsx";
import PostMetadata from "@/components/PostMetadata";
import { usePreloadPost } from "@/hooks/network/use-preload-post";
import { useInView } from "@/hooks/use-in-view";

type TProps = {
  data: TGenericPost;
};
export default function Post({ data: post }: TProps) {
  const slug = post.slug;
  const preloadPost = usePreloadPost(slug);
  const { ref } = useInView<HTMLLIElement>({
    triggerOnce: true,
    onChange(inView) {
      if (inView) {
        preloadPost();
      }
    },
  });
  const thumbnail = post.thumbnail;
  const link = LinkBuilder.build({
    route: "post",
    slug,
  });
  const commentsCount = post.commentsCount;
  const photosCount = post.photos.length;
  const observationsCount = post.observations.length;
  return (
    <li ref={ref} className={cls.root}>
      {thumbnail && (
        <Thumb postLink={link} thumbnail={thumbnail} photos={post.photos} />
      )}
      <h2 className={cls.header}>{post.title}</h2>
      <PostMetadata
        className={cls.meta}
        likesCount={post.likesCount}
        observationsCount={observationsCount}
        photosCount={photosCount}
        commentsCount={commentsCount}
        date={post.date}
      />
      <p className={cls.excerpt}>{post.excerpt}</p>
      <TagsList tags={post.tags} />
      <Link className={cn(cls.postLink, "btn")} to={link}>
        Читать
      </Link>
    </li>
  );
}
